// Shared look for text-entry controls (input, textarea, native select, select, combobox, number
// input), from the mockups' .w-amt: a recessed well with a hairline edge, not a lighter fill.

// Darker than the translucent card it sits on in dark; white on warm paper in light.
export const well = { _light: 'white', _dark: 'blackAlpha.400' }

// Neutral line that firms up on hover; the focus ring takes the palette color.
export const line = {
  borderWidth: '1px',
  borderColor: 'border',
  focusVisibleRing: 'inside',
  focusRingColor: 'colorPalette.focusRing',
  _hover: {
    borderColor: 'border.emphasized',
    _invalid: { borderColor: 'border.error' },
  },
}

// One family with the rest of the UI (production uses Lato in fields).
export const text = {
  fontFamily: 'body',
  _placeholder: { color: 'fg.subtle' },
}

export const variants = {
  subtle: { ...line, bg: well },
  outline: { ...line, bg: 'transparent' },
  filled: { ...line, bg: well, borderColor: 'transparent' },
  flushed: { bg: 'transparent', borderBottomColor: 'border' },
}

// Corners track the button sizes so a field and its button line up.
export const radii = {
  '2xs': { borderRadius: 'md' },
  xs: { borderRadius: 'md' },
  xl: { borderRadius: 'xl' },
  '2xl': { borderRadius: 'xl' },
}

// Pills (badges, tags): a faint tint of the palette with a matching hairline ring, like the
// mockups' .pill.go. Dark mixes the bright 400 step, since the palettes' opaque 900 subtles
// read muddy on translucent cards.
export const tint = {
  bg: { _light: 'colorPalette.subtle', _dark: 'colorPalette.400/12' },
  color: 'colorPalette.fg',
  shadow: 'inset 0 0 0px 1px var(--shadow-color)',
  shadowColor: { _light: 'colorPalette.muted', _dark: 'colorPalette.400/30' },
}
